import { CRS_CONSTANTS } from '../../pages/constants/crsContants';

import { ModelListModule } from './apiModules/DashboardModules/modelListModule';
import { ClusterChartModule } from './apiModules/DashboardModules/clusterChartModule';
import { ClusterFeaturesModule } from './apiModules/DashboardModules/clusterFeaturesModule';

export class NetworkLayer {
  constructor() {
    const { CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;
    this.baseUrl = CRS_BASE_URL;
    this.httpHeaders = HTTP_HEADERS;

    this.modelListModule = new ModelListModule(CRS_BASE_URL, HTTP_HEADERS);
    this.clusterChartModule = new ClusterChartModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.clusterFeaturesModule = new ClusterFeaturesModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
  }

  modelListAPI = async (payload) =>
    await this.modelListModule.fetchModelList(payload);
  clusterChartAPI = async (payload) =>
    await this.clusterChartModule.fetchClusterChartData(payload);
  clusterFeaturesAPI = async (payload) =>
    await this.clusterFeaturesModule.fetchClusterFeaturesData(payload);
}
